module.exports = __webpack_public_path__ + "img/Engie E&C.a9599236.png";